// dw-role
import Vue from 'vue'
import DwAuthorized from './dw-authorized'

function changeHasRole (el, binding) {
  const {value} = binding
  const permissionRoles = value
  console.debug('permissionRoles:')
  console.debug(permissionRoles)
  if (!hasRoleOrPermCode(permissionRoles)) {
    el.parentNode && el.parentNode.removeChild(el)
  }
  /* function roleCheck (permissionRoles) {
    const authority = DwAuthorized.getAuthority()
    for (let i=0; i<authority.length; i++) {
      console.debug(authority[i])
      console.debug(permissionRoles.includes(authority[i]))
      if (permissionRoles.includes(authority[i])) {
        return true
      }
    }
    return false
  } */
}

export function hasRoleOrPermCode (permissionRoles) {
  const authority = DwAuthorized.getAuthority()
  console.debug('authority')
  console.debug(authority)
  if (authority!=null) {
    const hasPermission = authority.some(role => {
      return permissionRoles.includes(role)
    })
    return hasPermission
  }
  return false
}

Vue.directive('hasDwRole', {
  inserted: function (el, binding) {
    changeHasRole(el, binding)
  }
})



// WEBPACK FOOTER //
// ./src/utils/dw-common.js